// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GJKB","placeholdersHeader":"styles_placeholdersHeader__1gkNE","editorStyle":"styles_editorStyle__1j6kr","placeholdersBox":"styles_placeholdersBox__24ePS"};